import application from "stimulus_application";
import RevealVideoController from "./reveal_video_controller";
import "./reveal_video.css";

application.register("reveal-video", RevealVideoController);
